export default {"src":"/_next/static/media/time.eafdf2ee.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};